var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConditionsOutlinePrimaryGradient = function SvgConditionsOutlinePrimaryGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 27.968a.81.81 0 0 1-.564-.232l-9.361-9.345-4.705-5.144a.856.856 0 0 1-.112-.156C-.758 9.774-.194 5.626 2.426 3c3.297-3.296 8.705-3.244 12.058.108l1.308 1.308L17.1 3.11c3.357-3.356 8.765-3.404 12.062-.108 3.292 3.297 3.244 8.705-.108 12.062L16.36 27.736a.793.793 0 0 1-.564.232h.004ZM2.418 12.238l4.613 5.045 8.77 8.753 12.125-12.11c2.728-2.728 2.776-7.124.108-9.797-2.673-2.672-7.065-2.62-9.798.108L16.36 6.114a.793.793 0 0 1-1.128 0L13.36 4.237c-2.729-2.732-7.125-2.78-9.798-.108C1.458 6.234.994 9.554 2.418 12.24Zm13.946 3.945 3.129-3.128 3.128-3.129a.802.802 0 0 0-1.132-1.132L15.8 14.483l-2.556-2.557a.802.802 0 0 0-1.132 1.133l3.124 3.124c.156.156.36.236.564.236.204 0 .408-.08.564-.236Z",
    fill: "url(#conditions-outline-primary-gradient_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "conditions-outline-primary-gradient_svg__a",
    x1: 15.8,
    y1: 0.56,
    x2: 22.763,
    y2: 26.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A93E5"
  })))));
};
export default SvgConditionsOutlinePrimaryGradient;